import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../css/dashboard.css";
import DashBox from "./component/dashitem";
import axios from 'axios';
import Menu from "./component/main_menu"
import { useAuthContext } from './common/ProtectedLayout';
import styled from "styled-components";

import { CSVLink } from "react-csv";

function DashBoard(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const auth = useAuthContext();

    // ✅ [New] 날짜 필터 상태 (기본값: 오늘)
    const getToday = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // ✅ [New] 한달 전 날짜 구하기
    const getOneMonthAgo = () => {
        const date = new Date();
        date.setMonth(date.getMonth() - 1);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const [startDate, setStartDate] = useState(getOneMonthAgo());
    const [endDate, setEndDate] = useState(getToday());

    const [totalCount, setTotalCount] = useState(0);
    const [userCount, setUserCount] = useState(0);
    const [managerCount, setManagerCount] = useState(0);
    const [totalCancelCount, setTotalCancelCount] = useState(0);
    const [notMatchingCount, setNotMatchingCount] = useState(0);
    const [matchingCount, setMatchingCount] = useState(0);
    const [asCount, setASCount] = useState(0);
    const [couponCount, setCouponCount] = useState(0);
    // ✅ [New] 전체 정산 내역 건수 상태
    const [bilingCount, setBilingCount] = useState(0);
    // ✅ [New] 로딩 상태
    const [isLoading, setIsLoading] = useState(false);

    // ✅ [Updated] API 호출 시 날짜 파라미터 전달
    const getReservationCount = async () => {
        try {
            const reserve_result = await axios.get('/Reservation/TotalCount', { params: { startDate, endDate } });
            setTotalCount(reserve_result.data.message)
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };

    const getUserCount = async () => {
        try {
            const user_result = await axios.get('/UserRegistCount', { params: { startDate, endDate } });
            setUserCount(user_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }

    const getManagerCount = async () => {
        try {
            const manger_result = await axios.get('/ManagerRegistCount', { params: { startDate, endDate } });
            setManagerCount(manger_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }
    const getTotalCancelCount = async () => {
        try {
            const cancel_result = await axios.get('/Reservation/CancelCount', { params: { startDate, endDate } });
            setTotalCancelCount(cancel_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }
    const getMatchingCount = async () => {
        try {
            const mat_result = await axios.get('/Reservation/MatchingCount', { params: { startDate, endDate } });
            setMatchingCount(mat_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }
    const getNotMatchingCount = async () => {
        try {
            const notmat_result = await axios.get('/Reservation/NotMatchingCount', { params: { startDate, endDate } });
            setNotMatchingCount(notmat_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }
    const getASCount = async () => {
        try {
            const as_result = await axios.get('/ASRegistCount', { params: { startDate, endDate } });
            setASCount(as_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }
    const getCouponCount = async () => {
        try {
            const coupon_result = await axios.get('/CouponTotalRegistCount', { params: { startDate, endDate } });
            setCouponCount(coupon_result.data.message || 0);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }

    // ✅ [New] 전체 정산 내역 건수 조회
    const getBilingCount = async () => {
        try {
            const biling_result = await axios.get('/Biling/RequestCount', { params: { startDate, endDate } });
            setBilingCount(biling_result.data.message);
        } catch (error) {
            console.error('Error fetching biling count:', error.message);
        }
    }

    // ✅ [New] 데이터 조회 함수 (로딩 처리 포함)
    const fetchData = async () => {
        setIsLoading(true);
        try {
            await Promise.all([
                getReservationCount(),
                getUserCount(),
                getManagerCount(),
                getTotalCancelCount(),
                getNotMatchingCount(),
                getMatchingCount(),
                getASCount(),
                getCouponCount(),
                getBilingCount() // ✅ 추가
            ]);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setIsLoading(false);
        }
    };

    // ✅ [Updated] 초기 로드 시에만 실행 (날짜 변경 시 자동 실행 X)
    useEffect(() => {
        fetchData();
    }, [location.state, navigate]); // startDate, endDate 의존성 제거

    // ✅ [New] 엑셀 데이터 준비
    const csvHeaders = [
        { label: "항목", key: "category" },
        { label: "수량", key: "count" }
    ];

    const csvData = [
        { category: "전체오더", count: totalCount },
        { category: "배정", count: matchingCount },
        { category: "미배정", count: notMatchingCount },
        { category: "A/S", count: asCount },
        { category: "예약취소", count: totalCancelCount },
        { category: "누적 가입자수", count: userCount },
        { category: "전체 정산 내역", count: bilingCount }, // ✅ 실제 데이터 연결
        { category: "쿠폰사용수량", count: '--' }, // 미사용 기능
        { category: "쿠폰발급 수량", count: couponCount }
    ];

    return (
        <PageContainer>
            {/* ✅ [New] 로딩 인디케이터 */}
            {isLoading && (
                <LoadingOverlay>
                    <div className="loading-spinner"></div>
                </LoadingOverlay>
            )}

            <ContentWrapper>
                {/* ✅ [Updated] 날짜 선택기 및 조회 버튼 + 백업 버튼 */}
                <FilterSection>
                    <DateFilterGroup>
                        <Label>조회 기간:</Label>
                        <StyledInput
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                        <span>~</span>
                        <StyledInput
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                        <SearchButton onClick={fetchData}>조회</SearchButton>
                    </DateFilterGroup>

                    {/* ✅ [New] 백업 버튼 */}
                    <CSVLink
                        data={csvData}
                        headers={csvHeaders}
                        filename={`${getToday()}_Backup.csv`}
                        style={{ textDecoration: 'none' }}
                    >
                        <BackupButton>백업</BackupButton>
                    </CSVLink>
                </FilterSection>

                <GridContainer>
                    <DashBox title="전체오더" data={totalCount} />
                    <DashBox title="배정" data={matchingCount} />
                    <DashBox title="미배정" data={notMatchingCount} />
                    <DashBox title="A/S" data={asCount} />
                    <DashBox title="예약취소" data={totalCancelCount} />
                    <DashBox title="누적 가입자수" data={userCount} />
                    <DashBox title="전체 정산 내역" data={bilingCount} />
                    <DashBox title="쿠폰사용수량" data={'--'} />
                    <DashBox title="쿠폰발급 수량" data={couponCount || 0} />
                </GridContainer>
            </ContentWrapper>
        </PageContainer>
    );
}

// --- Styled Components ---

const PageContainer = styled.div`
    position: relative;
    padding: 0px; 
    background-color: #f5f6f8;
    min-height: 100vh;
    display: flex;
    justify-content: center;
`;

const ContentWrapper = styled.div`
    width: 100%;
    max-width: 1400px;
    padding: 25px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const FilterSection = styled.div`
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 20px 30px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.03);
`;

const DateFilterGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 1rem;
    color: #495057;
`;

const Label = styled.span`
    font-weight: 700;
    color: #343a40;
    margin-right: 5px;
`;

const StyledInput = styled.input`
    padding: 8px 12px;
    border-radius: 6px;
    border: 1px solid #dee2e6;
    font-size: 0.95rem;
    color: #495057;
    &:focus { outline: 2px solid #006edc; border-color: transparent; }
`;

const ButtonBase = styled.div` // div for CSLink child or button
    padding: 8px 20px;
    border-radius: 6px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 0.95rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

const SearchButton = styled.button`
    padding: 8px 24px;
    background-color: #006edc;
    color: white;
    border: none;
    border-radius: 6px;
    font-weight: 700;
    font-size: 0.95rem;
    cursor: pointer;
    transition: background-color 0.2s;
    &:hover { background-color: #0056b3; }
`;

const BackupButton = styled(ButtonBase)`
    background-color: #20c997;
    color: white;
    &:hover { background-color: #12b886; }
`;

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px 30px; /* Reduced vertical gap to match margin */
    width: 100%;
    
    @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 800px) {
        grid-template-columns: 1fr;
    }
`;

export default DashBoard;